/**
 * SLV2-2823: render a customer/location name with its Navision XM_ID beside it —
 * "EXAMINETICS (100003)". The identifier is the only way to tell identically-named
 * records apart (the six-Examinetics problem), so every listing and dropdown that
 * shows a customer or customer-location name should use this.
 * Falls back to the bare name when the record has no XM_ID (~0.3% of rows).
 */
export function withXmId(name: string | null | undefined, xmId: string | null | undefined): string {
  const n = (name ?? '').trim();
  const x = (xmId ?? '').trim();
  if (!x) return n;
  return n ? `${n} (${x})` : `(${x})`;
}
